import { Option } from '@beeline/design-system-react/extracted-styles';

import { BookingObject } from 'src/types';

import { RoomBookingFilters, RoomsState, Slots } from './types';

export const emptyBookingObjects = new Map<string, BookingObject>();

export const emptySlots: Slots = {
  bookedPeriods: [],
  freePeriods: [],
  requestId: undefined,
};

export const emptySeatCount: Option<number>[] = [];

export const defaultRoomBookingFilters: RoomBookingFilters = {
  seatCount: emptySeatCount,
  withFlipChart: false,
  withTv: false,
  withVideoCalls: false,
  withWater: false,
};

export const initialState: RoomsState = {
  loading: false,
  locationLoading: false,
  bookingObjects: emptyBookingObjects,
  staticObjects: emptyBookingObjects,
  date: undefined,
  time: '',
  filters: defaultRoomBookingFilters,
  currentRequestId: undefined,
  slots: emptySlots,
  slotsLoading: false,
  roomBookingSheetIsOpened: false,
  ...defaultRoomBookingFilters,
};
